import axios from "axios";

export default {
  getItems: function (baseApiUrl, artikelvisningsurl, orgId, take, skip, nyckelord) {
    let lang = document.documentElement.lang;
    var response = axios.post(
        baseApiUrl +
        "/Artikel?artikelvisningsurl=" +
        artikelvisningsurl +
        "&orgId=" +
        orgId +
        "&lang=" +
        lang +
        "&take=" +
        take + 
        "&skip=" +
        skip + 
        "&nyckelord=" +
        nyckelord
    );
    return response;
  },
};